import { render, staticRenderFns } from "./comm.vue?vue&type=template&id=395ba3c0&scoped=true"
import script from "./comm.vue?vue&type=script&lang=js"
export * from "./comm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395ba3c0",
  null
  
)

export default component.exports